var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleToken({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.48926 7.99967C1.48926 4.31777 4.47402 1.33301 8.15592 1.33301C11.8378 1.33301 14.8226 4.31777 14.8226 7.99967C14.8226 11.6815 11.8378 14.6663 8.15592 14.6663C4.47402 14.6663 1.48926 11.6815 1.48926 7.99967ZM10.8729 5.2878C11.1741 5.49969 11.2463 5.91556 11.0345 6.21667L7.86779 10.7167C7.75132 10.8821 7.56606 10.9858 7.36412 10.9984C7.16212 11.011 6.96539 10.9312 6.82932 10.7815L5.16263 8.94814C4.91496 8.67567 4.93504 8.25407 5.20748 8.00641C5.47991 7.75874 5.90154 7.77881 6.14922 8.05121L7.25619 9.26894L9.94406 5.44935C10.1559 5.14823 10.5718 5.07591 10.8729 5.2878Z",
    fill: "#10A37F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleToken);
export default __webpack_public_path__ + "static/media/checkCircleToken.761e87e53e2d33de8a1e42ffef6315bc.svg";
export { ForwardRef as ReactComponent };